import React from 'react'

import { Helmet } from 'react-helmet'

import './terms.css'

const Terms = (props) => {
  return (
    <div className="terms-container">
      <Helmet>
        <title>
          Terms - FutureHeirs | Faith-Based Non-Profit Empowering Future Leaders
        </title>
        <meta
          name="description"
          content="Faith-based non-profit bridging quality education and accessibility. Empowering children through Christ-centered learning, tech literacy &amp; character development"
        />
        <meta
          property="og:title"
          content="Terms - FutureHeirs | Faith-Based Non-Profit Empowering Future Leaders"
        />
        <meta
          property="og:description"
          content="Bridging quality education and accessibility through Christ-centered learning. Empowering every child to flourish in their unique calling with faith and innovation."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/97765a8c-e132-4703-821d-7a550778f912/2688ccf9-cb16-49f3-aba4-ad25e1010654?org_if_sml=1&amp;force_format=original"
        />
      </Helmet>
      <div className="terms-termsand-conditions">
        <div className="terms-frame12">
          <div className="terms-frame15">
            <div className="terms-frame162">
              <img
                alt="VectorI372"
                src="/external/vectori372-mahf.svg"
                className="terms-vector1"
              />
              <span className="terms-text100">futureheirs</span>
            </div>
            <div className="terms-frame81">
              <div className="terms-frame6">
                <span className="terms-text101">Home</span>
              </div>
              <div className="terms-frame7">
                <span className="terms-text102">About Us</span>
              </div>
              <div className="terms-frame82">
                <span className="terms-text103">Contact Us</span>
              </div>
              <div className="terms-frame9">
                <span className="terms-text104">Blog</span>
              </div>
            </div>
            <div className="terms-component4">
              <span className="terms-text105">Join Us</span>
            </div>
          </div>
          <div className="terms-frame13">
            <div className="terms-frame195">
              <img
                alt="Line653122"
                src="/external/line653122-kei.svg"
                className="terms-line65"
              />
              <span className="terms-text106">Terms and Conditions</span>
            </div>
            <span className="terms-text107">
              Review our terms and conditions to understand your rights and
              responsibilities while using our platform.
            </span>
          </div>
        </div>
        <img
          alt="Rectangle43122"
          src="/external/rectangle43122-q0bo.svg"
          className="terms-rectangle4"
        />
        <div className="terms-frame2988">
          <div className="terms-frame2987">
            <div className="terms-frame1144">
              <div className="terms-frame218">
                <span className="terms-text108">Introduction</span>
                <span className="terms-text109">
                  Welcome to FutureHeirs. These Terms and Conditions
                  (&quot;Terms&quot;) govern your use of our website and
                  services. By accessing or using our website, you agree to be
                  bound by these Terms. If you disagree with any part of these
                  Terms, you may not access our website or use our services.
                </span>
              </div>
              <div className="terms-frame219">
                <span className="terms-text110">Definitions</span>
                <span className="terms-text111">
                  <span>
                    &quot;FutureHeirs,&quot; &quot;we,&quot; &quot;us,&quot; and
                    &quot;our&quot; refer to FutureHeirs organization.
                  </span>
                  <br></br>
                  <span>
                    &quot;Website&quot; refers to our website located at
                    www.futureheirs.org and all associated subdomains.
                  </span>
                  <br></br>
                  <span>
                    &quot;Services&quot; refers to the educational programs,
                    resources, and other services offered by FutureHeirs.
                  </span>
                  <br></br>
                  <span>
                    &quot;User,&quot; &quot;you,&quot; and &quot;your&quot;
                    refer to individuals accessing or using our website or
                    services.
                  </span>
                  <br></br>
                  <span>
                    &quot;Content&quot; refers to text, images, graphics, logos,
                    audio, video, information, and other materials.
                  </span>
                </span>
              </div>
              <div className="terms-frame220">
                <span className="terms-text121">
                  Use of Website and Services
                </span>
                <div className="terms-frame11491">
                  <div className="terms-frame11451">
                    <span className="terms-text122">Acceptable Use</span>
                    <span className="terms-text123">
                      <span>
                        You agree to use our website and services only for
                        lawful purposes and in accordance with these Terms. You
                        agree not to:
                      </span>
                      <br></br>
                      <span>
                        Use our website in any way that violates any applicable
                        federal, state, local, or international law or
                        regulation
                      </span>
                      <br></br>
                      <span>
                        Impersonate or attempt to impersonate FutureHeirs, a
                        FutureHeirs employee, or another user
                      </span>
                      <br></br>
                      <span>
                        Engage in any conduct that restricts or inhibits
                        anyone&apos;s use of our website
                      </span>
                      <br></br>
                      <span>
                        Use our website or services for any unauthorized or
                        illegal purpose
                      </span>
                      <br></br>
                      <span>
                        Attempt to gain unauthorized access to our website, user
                        accounts, or computer systems
                      </span>
                      <br></br>
                      <span>
                        Transmit viruses, malware, or other malicious code
                      </span>
                    </span>
                  </div>
                  <div className="terms-frame11471">
                    <span className="terms-text137">User Accounts</span>
                    <span className="terms-text138">
                      When creating an account on our website, you must provide
                      accurate and complete information. You are responsible for
                      maintaining the confidentiality of your account
                      credentials and for all activities that occur under your
                      account. You agree to notify us immediately of any
                      unauthorized access to or use of your account.
                    </span>
                  </div>
                  <div className="terms-frame11481">
                    <span className="terms-text139">Content Submission</span>
                    <span className="terms-text140">
                      <span>
                        If you submit content to our website (such as
                        testimonials, comments, or program applications), you:
                      </span>
                      <br></br>
                      <span>
                        Grant FutureHeirs a non-exclusive, royalty-free,
                        transferable, sublicensable, worldwide license to use,
                        store, display, reproduce, and distribute your content
                      </span>
                      <br></br>
                      <span>
                        Represent and warrant that you own or have the necessary
                        rights to submit such content
                      </span>
                      <br></br>
                      <span>
                        Agree that your content does not violate the rights of
                        any third party or any applicable laws
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div className="terms-frame221">
                <span className="terms-text148">Intellectual Property</span>
                <div className="terms-frame11492">
                  <div className="terms-frame11452">
                    <span className="terms-text149">
                      Our Intellectual Property
                    </span>
                    <span className="terms-text150">
                      The website and its entire contents, features, and
                      functionality (including but not limited to all
                      information, software, text, displays, images, video, and
                      audio, and the design, selection, and arrangement
                      thereof), are owned by FutureHeirs, its licensors, or
                      other providers of such material and are protected by
                      United States and international copyright, trademark,
                      patent, trade secret, and other intellectual property or
                      proprietary rights laws.
                    </span>
                  </div>
                  <div className="terms-frame11472">
                    <span className="terms-text151">Limited License</span>
                    <span className="terms-text152">
                      <span>
                        We grant you a limited, non-exclusive, non-transferable,
                        revocable license to access and use our website and
                        services for personal, non-commercial purposes. This
                        license does not include:
                      </span>
                      <br></br>
                      <span>Modifying or copying our materials</span>
                      <br></br>
                      <span>
                        Using any materials for any commercial purpose
                      </span>
                      <br></br>
                      <span>
                        Attempting to decompile or reverse engineer any software
                        contained on our website
                      </span>
                      <br></br>
                      <span>
                        Removing any copyright or other proprietary notations
                        from the materials
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div className="terms-frame222">
                <span className="terms-text162">Donations and Payments</span>
                <div className="terms-frame11493">
                  <div className="terms-frame11453">
                    <span className="terms-text163">Donations</span>
                    <span className="terms-text164">
                      All donations to FutureHeirs are voluntary and
                      non-refundable. By making a donation, you acknowledge that
                      you are not receiving any goods or services in exchange
                      for your donation, except as specifically indicated.
                    </span>
                  </div>
                  <div className="terms-frame11473">
                    <span className="terms-text165">Payment Processing</span>
                    <span className="terms-text166">
                      We use third-party payment processors to handle donations
                      and program fees. Your use of these services is subject to
                      the terms and privacy policies of these third-party
                      processors.
                    </span>
                  </div>
                  <div className="terms-frame11482">
                    <span className="terms-text167">Tax Deductions</span>
                    <span className="terms-text168">
                      FutureHeirs is a 501(c)(3) tax-exempt organization.
                      Donations may be tax-deductible to the extent allowed by
                      law. We recommend consulting with a tax professional
                      regarding the tax implications of your donation.
                    </span>
                  </div>
                </div>
              </div>
              <div className="terms-frame223">
                <span className="terms-text169">Liability Limitations</span>
                <div className="terms-frame11494">
                  <div className="terms-frame11454">
                    <span className="terms-text170">
                      Disclaimer of Warranties
                    </span>
                    <span className="terms-text171">
                      Our website and services are provided on an &quot;as
                      is&quot; and &quot;as available&quot; basis, without any
                      warranties of any kind, either express or implied.
                      FutureHeirs disclaims all warranties, including but not
                      limited to implied warranties of merchantability, fitness
                      for a particular purpose, and non-infringement.
                    </span>
                  </div>
                  <div className="terms-frame11474">
                    <span className="terms-text172">
                      Limitation of Liability
                    </span>
                    <span className="terms-text173">
                      In no event shall FutureHeirs, its directors, employees,
                      partners, agents, suppliers, or affiliates be liable for
                      any indirect, incidental, special, consequential, or
                      punitive damages, including without limitation, loss of
                      profits, data, use, goodwill, or other intangible losses,
                      resulting from your access to or use of or inability to
                      access or use our website or services.
                    </span>
                  </div>
                  <div className="terms-frame11483">
                    <span className="terms-text174">Tax Deductions</span>
                    <span className="terms-text175">
                      FutureHeirs is a 501(c)(3) tax-exempt organization.
                      Donations may be tax-deductible to the extent allowed by
                      law. We recommend consulting with a tax professional
                      regarding the tax implications of your donation.
                    </span>
                  </div>
                </div>
              </div>
              <div className="terms-frame224">
                <span className="terms-text176">Indemnification</span>
                <span className="terms-text177">
                  You agree to defend, indemnify, and hold harmless FutureHeirs,
                  its directors, employees, volunteers, agents, contractors, and
                  affiliates from and against any claims, liabilities, damages,
                  judgments, awards, losses, costs, expenses, or fees (including
                  reasonable attorneys&apos; fees) arising out of or relating to
                  your violation of these Terms or your use of our website or
                  services.
                </span>
              </div>
              <div className="terms-frame225">
                <span className="terms-text178">
                  Governing Law and Jurisdiction
                </span>
                <span className="terms-text179">
                  These Terms shall be governed by and construed in accordance
                  with the laws of the state where FutureHeirs is headquartered,
                  without regard to its conflict of law provisions. You agree to
                  submit to the personal and exclusive jurisdiction of the
                  courts located within that state for the resolution of any
                  disputes.
                </span>
              </div>
              <div className="terms-frame226">
                <span className="terms-text180">Modifications to Terms</span>
                <span className="terms-text181">
                  We reserve the right to modify these Terms at any time. We
                  will provide notice of any material changes by posting the
                  updated Terms on this page and updating the &quot;Last
                  Updated&quot; date. Your continued use of our website after
                  such modifications will constitute your acknowledgment of the
                  modified Terms and agreement to be bound by them.
                </span>
              </div>
              <div className="terms-frame227">
                <span className="terms-text182">Severability</span>
                <span className="terms-text183">
                  If any provision of these Terms is held to be unenforceable or
                  invalid, such provision will be changed and interpreted to
                  accomplish the objectives of such provision to the greatest
                  extent possible under applicable law, and the remaining
                  provisions will continue in full force and effect.
                </span>
              </div>
              <div className="terms-frame228">
                <span className="terms-text184">Contact Information</span>
                <span className="terms-text185">
                  <span>
                    If you have any questions about these Terms, please contact
                    us at:
                  </span>
                  <br></br>
                  <span>
                    FutureHeirs  123 Faith &amp; Innovation Way  Your City,
                    State 12345  legal@futureheirs.org  (555) 123-4567
                  </span>
                </span>
              </div>
            </div>
            <div className="terms-frame2986">
              <img
                alt="Line693142"
                src="/external/line693142-gqxk.svg"
                className="terms-line69"
              />
              <img
                alt="Line703142"
                src="/external/line703142-ovl5.svg"
                className="terms-line70"
              />
              <div className="terms-frame2968">
                <div className="terms-frame29661">
                  <img
                    alt="Ellipse1803142"
                    src="/external/ellipse1803142-cqo7-200w.png"
                    className="terms-ellipse1801"
                  />
                </div>
                <span className="terms-text189">Introduction</span>
              </div>
              <div className="terms-frame2970">
                <div className="terms-frame29662">
                  <img
                    alt="Ellipse1803142"
                    src="/external/ellipse1803142-fwvb-200w.png"
                    className="terms-ellipse1802"
                  />
                </div>
                <span className="terms-text190">Definitions</span>
              </div>
              <div className="terms-frame2971">
                <div className="terms-frame29851">
                  <div className="terms-frame29721"></div>
                </div>
                <div className="terms-frame1152">
                  <span className="terms-text191">
                    Use of Website and Services
                  </span>
                  <div className="terms-frame1151">
                    <span className="terms-text192">Acceptable Use</span>
                    <span className="terms-text193">User Accounts</span>
                    <span className="terms-text194">Content Submission</span>
                  </div>
                </div>
              </div>
              <div className="terms-frame2973">
                <div className="terms-frame29852">
                  <div className="terms-frame29722"></div>
                </div>
                <div className="terms-frame1154">
                  <span className="terms-text195">Intellectual Property</span>
                  <div className="terms-frame1153">
                    <span className="terms-text196">
                      Our Intellectual Property
                    </span>
                    <span className="terms-text197">Limited License</span>
                  </div>
                </div>
              </div>
              <div className="terms-frame2975">
                <div className="terms-frame29853">
                  <div className="terms-frame29723"></div>
                </div>
                <div className="terms-frame1156">
                  <span className="terms-text198">Donations and Payments</span>
                  <div className="terms-frame1155">
                    <span className="terms-text199">Donations</span>
                    <span className="terms-text200">Payment Processing</span>
                    <span className="terms-text201">Tax Deductions</span>
                  </div>
                </div>
              </div>
              <div className="terms-frame2977">
                <div className="terms-frame29854">
                  <div className="terms-frame29724"></div>
                </div>
                <div className="terms-frame1158">
                  <span className="terms-text202">Liability Limitations</span>
                  <div className="terms-frame1157">
                    <span className="terms-text203">
                      Disclaimer of Warranties
                    </span>
                    <span className="terms-text204">
                      Limitation of Liability
                    </span>
                    <span className="terms-text205">Tax Deductions</span>
                  </div>
                </div>
              </div>
              <div className="terms-frame2979">
                <div className="terms-frame2976"></div>
                <span className="terms-text206">Indemnification</span>
              </div>
              <div className="terms-frame2981">
                <div className="terms-frame2978"></div>
                <span className="terms-text207">
                  Governing Law and Jurisdiction
                </span>
              </div>
              <div className="terms-frame2983">
                <div className="terms-frame2980"></div>
                <span className="terms-text208">Modifications to Terms</span>
              </div>
              <div className="terms-frame2984">
                <div className="terms-frame29821"></div>
                <span className="terms-text209">Severability</span>
              </div>
              <div className="terms-frame29855">
                <div className="terms-frame29822"></div>
                <span className="terms-text210">Contact Information</span>
              </div>
            </div>
          </div>
          <div className="terms-frame189">
            <div className="terms-frame184">
              <div className="terms-group107">
                <span className="terms-text211">Company</span>
                <div className="terms-frame2491">
                  <span className="terms-text212">Home</span>
                  <span className="terms-text213">About Us</span>
                  <span className="terms-text214">Contact Us</span>
                  <span className="terms-text215">Programs</span>
                  <span className="terms-text216">Approach</span>
                </div>
              </div>
              <div className="terms-group106">
                <span className="terms-text217">Quick Links</span>
                <div className="terms-frame2492">
                  <span className="terms-text218">Partner with Us</span>
                  <span className="terms-text219">Volunteer</span>
                  <span className="terms-text220">Donate</span>
                  <span className="terms-text221">Blog</span>
                </div>
              </div>
              <div className="terms-group105">
                <span className="terms-text222">Terms and Policies</span>
                <div className="terms-frame248">
                  <span className="terms-text223">Privacy Policy</span>
                  <span className="terms-text224">Terms and Conditions</span>
                  <span className="terms-text225">Feedback</span>
                  <span className="terms-text226">FAQs</span>
                </div>
              </div>
              <div className="terms-group104">
                <span className="terms-text227">Contact Information</span>
                <div className="terms-group87">
                  <span className="terms-text228">connect@futureheirs.org</span>
                  <div className="terms-vuesaxboldsms1">
                    <div className="terms-vuesaxboldsms2">
                      <div className="terms-sms">
                        <img
                          alt="VectorI312"
                          src="/external/vectori312-d5kp.svg"
                          className="terms-vector2"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="terms-group88">
                  <span className="terms-text229">
                    123 Faith &amp; Innovation Way, Your City, State 12345
                  </span>
                  <div className="terms-vuesaxboldlocation1">
                    <div className="terms-vuesaxboldlocation2">
                      <img
                        alt="VectorI312"
                        src="/external/vectori312-g75o.svg"
                        className="terms-vector3"
                      />
                    </div>
                  </div>
                </div>
                <div className="terms-group89">
                  <span className="terms-text230">(555) 123-4567</span>
                  <div className="terms-vuesaxboldcall1">
                    <div className="terms-vuesaxboldcall2">
                      <div className="terms-call">
                        <img
                          alt="VectorI312"
                          src="/external/vectori312-mkz2.svg"
                          className="terms-vector4"
                        />
                        <img
                          alt="VectorI312"
                          src="/external/vectori312-kotf.svg"
                          className="terms-vector5"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <img
              alt="Line2I312"
              src="/external/line2i312-h84.svg"
              className="terms-line2"
            />
            <div className="terms-frame183">
              <div className="terms-frame161">
                <img
                  alt="VectorI312"
                  src="/external/vectori312-ct84.svg"
                  className="terms-vector6"
                />
                <span className="terms-text231">futureheirs</span>
              </div>
              <div className="terms-frame180">
                <span className="terms-text232">Follow Us:</span>
                <div className="terms-frame177">
                  <div className="terms-vuesaxboldfacebook1">
                    <div className="terms-vuesaxboldfacebook2">
                      <div className="terms-facebook">
                        <img
                          alt="VectorI312"
                          src="/external/vectori312-5ja8.svg"
                          className="terms-vector7"
                        />
                      </div>
                    </div>
                  </div>
                  <img
                    alt="riinstagramfillI312"
                    src="/external/riinstagramfilli312-wj8v.svg"
                    className="terms-riinstagramfill"
                  />
                  <img
                    alt="pajamaslinkedinI312"
                    src="/external/pajamaslinkedini312-age.svg"
                    className="terms-pajamaslinkedin"
                  />
                  <img
                    alt="fa6brandssquarextwitterI312"
                    src="/external/fa6brandssquarextwitteri312-3eq9.svg"
                    className="terms-fa6brandssquarextwitter"
                  />
                  <div className="terms-vuesaxboldyoutube1">
                    <div className="terms-vuesaxboldyoutube2">
                      <div className="terms-youtube">
                        <img
                          alt="VectorI312"
                          src="/external/vectori312-stbp3.svg"
                          className="terms-vector8"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Terms
